/*
 * AdminBAAPage — global-admin dashboard for institutional BAA requests.
 *
 * Served at /admin/baa/requests (list) and /admin/baa/requests/:requestId
 * (detail). The route is gated by RequireGlobalAdmin in AppRoutes.jsx; this
 * component re-checks the claim defensively so it is safe to render directly.
 */
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import Loading from "components/Loading";
import BAARequestsList from "./BAARequestsList";
import BAARequestDetail from "./BAARequestDetail";

export default function AdminBAAPage() {
  const { isGlobalAdmin, userLoading } = useAuth();
  const { requestId } = useParams();

  if (userLoading) return <Loading page />;
  if (!isGlobalAdmin) return <Navigate to="/" replace />;

  return requestId ? (
    <BAARequestDetail requestId={requestId} />
  ) : (
    <BAARequestsList />
  );
}
